import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import SweetAlert2 from "react-sweetalert2";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import * as actions from "../redux/CompanyGameAction";
import { ManageGameDialog } from "./createGame/ManageGameDialog";

const GameStatus = {
  Pending: 1,
  OnHold: 2,
  Publish: 3,
};

export const CompanyGameListing = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [item, setItem] = useState(undefined);
  const [gameStatus, setGameStatus] = useState(GameStatus.Pending);
  const [companycode, setCompanycode] = useState("");
  const [gametype, setGametype] = useState("");
  const [gamenameen, setGamenameen] = useState("");
  const [swalProps, setSwalProps] = useState({});
  const [queryParams, setQueryParams] = useState();
  const [isShowLoading, setIsShowLoading] = useState(false);

  const columnClass = "p-3";

  const companyGameState = useSelector(
    ({ companyGame }) => companyGame,
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.fetchCompanyList()).then((res) => {
      res = res.data;
      if (res) {
        const selected = res.gameTypes[0];
        setQueryParams({
          gamenameen: "",
          companycode: selected.companylists[0].companycode,
          gametype: selected.gametype,
        });
        setCompanycode(selected.companylists[0].companycode);
        setGametype(selected.gametype);
      }
    });
  }, []);

  useEffect(() => {
    if (queryParams) dispatch(actions.fetchCompanyGame(queryParams));
  }, [queryParams]);

  const handleDelete = (itemid) => {
    setSwalProps({
      show: true,
      icon: "question",
      title: intl.formatMessage({ id: "confirmation" }),
      text: intl.formatMessage({ id: "questionRemoveSelectedGame" }),
      showCancelButton: true,
      onConfirm: () => {
        dispatch(
          actions.deleteCompanyGame({
            itemid,
            gametype: queryParams.gametype,
          })
        ).then((resp) => {
          resp = resp.data;
          if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
            setSwalProps({
              show: true,
              icon: "success",
              title: intl.formatMessage({ id: "success" }),
              text: intl.formatMessage({ id: "removeGameSuccessfully" }),
            });
          } else {
            setSwalProps({
              show: true,
              icon: "error",
              title: intl.formatMessage({ id: "error" }),
              text: resp.message,
            });
          }
        });
      },
    });
  };

  const handlePublish = () => {
    console.log("zzz");
    setSwalProps({
      show: true,
      icon: "question",
      title: intl.formatMessage({ id: "confirmation" }),
      text: intl.formatMessage({ id: "questionPublishPendGame" }),
      showCancelButton: true,
      onConfirm: () => {
        dispatch(
          actions.publishPendingGame({
            companycode: queryParams.companycode,
            gametype: queryParams.gametype,
          })
        ).then((resp) => {
          resp = resp.data;
          if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
            dispatch(actions.fetchCompanyGame(queryParams));
            setSwalProps({
              show: true,
              icon: "success",
              title: intl.formatMessage({ id: "success" }),
              text: intl.formatMessage({ id: "publishGameSuccessfully" }),
            });
          } else {
            setSwalProps({
              show: true,
              icon: "error",
              title: intl.formatMessage({ id: "error" }),
              text: resp.message,
            });
          }
        });
      },
    });
  };

  return (
    <div className="px-4">
      <SweetAlert2
        customClass="custom-swal"
        onResolve={() => {
          setSwalProps({});
        }}
        {...swalProps}
      />
      {(companyGameState.actionsLoading || isShowLoading) && (
        <div
          className="position-fixed w-100 top-0 start-0 end-0 bottom-0 d-flex align-items-center justify-content-center"
          style={{
            scale: "1.5",
            background: "rgba(0,0,0,0.3)",
            zIndex: "9999",
          }}
        >
          <div className="spinner-border" role="status">
            <span className="sr-only"></span>
          </div>
        </div>
      )}
      <ManageGameDialog
        setShow={setShow}
        show={show}
        setSwalProps={setSwalProps}
        companycode={queryParams?.companycode}
        gametype={queryParams?.gametype}
        setIsShowLoading={setIsShowLoading}
        item={item}
      />
      <div className="d-flex align-items-center justify-content-between mb-4">
        <h2 className="m-0 p-0">{intl.formatMessage({ id: "companyGame" })}</h2>
      </div>
      <div className="my-2 row mb-3">
        <div className="col-md-3">
          <div>{intl.formatMessage({ id: "gameType" })}</div>
          <select
            className="dropdown respond-Select w-100"
            value={gametype}
            onChange={(e) => {
              setGametype(e.target.value);
              setCompanycode(
                companyGameState.companyList?.gameTypes?.find(
                  (gameType) => gameType.gametype === e.target.value
                )?.companylists[0].companycode
              );
            }}
          >
            {companyGameState.companyList?.gameTypes?.map((gameType) => (
              <option value={gameType.gametype} key={gameType.gametype}>
                {gameType.gametype}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-3">
          <div>{intl.formatMessage({ id: "company" })}</div>
          <select
            className="dropdown respond-Select w-100"
            value={companycode}
            onChange={(e) => setCompanycode(e.target.value)}
          >
            {companyGameState.companyList?.gameTypes
              ?.find((gameType) => gameType.gametype === gametype)
              ?.companylists.map((company) => (
                <option value={company.companycode} key={company.companycode}>
                  {company.companyname}
                </option>
              ))}
          </select>
        </div>
        <div className="col-md-3">
          <div>{intl.formatMessage({ id: "gameName" })}</div>
          <input
            type="text"
            className="refund-Input w-100 mt-1"
            placeholder={intl.formatMessage({ id: "gameName" })}
            value={gamenameen}
            onChange={(e) => setGamenameen(e.target.value)}
          />
        </div>
        <div className="col-md-3 mt-4 d-flex justify-content-end">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              setQueryParams({
                gamenameen,
                companycode,
                gametype,
              });
            }}
          >
            {intl.formatMessage({ id: "search" })}
          </button>
        </div>
      </div>
      <div className="mb-2 d-flex justify-content-end gap-3">
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => {
            setItem(undefined);
            setShow(true);
          }}
        >
          {intl.formatMessage({ id: "addGame" })}
        </button>
      </div>
      <div
        className="d-flex border mb-2"
        style={{ background: "var(--table-background)" }}
      >
        <div
          className={`py-2 col-4 text-center ${
            gameStatus === GameStatus.Pending
              ? "bg-primary text-white fw-bold"
              : ""
          }`}
          style={{ cursor: "pointer" }}
          onClick={() => setGameStatus(GameStatus.Pending)}
        >
          {intl.formatMessage({ id: "pending" })} (
          {companyGameState.companyGame?.totalpend ?? "0"})
        </div>
        <div
          className={`py-2 col-4 text-center ${
            gameStatus === GameStatus.OnHold
              ? "bg-primary text-white fw-bold"
              : ""
          }`}
          style={{ cursor: "pointer" }}
          onClick={() => setGameStatus(GameStatus.OnHold)}
        >
          {intl.formatMessage({ id: "onHold" })}
        </div>
        <div
          className={`py-2 col-4 text-center ${
            gameStatus === GameStatus.Publish
              ? "bg-primary text-white fw-bold"
              : ""
          }`}
          style={{ cursor: "pointer" }}
          onClick={() => setGameStatus(GameStatus.Publish)}
        >
          {intl.formatMessage({ id: "published" })}
        </div>
      </div>
      {gameStatus === GameStatus.Pending &&
        parseInt(companyGameState.companyGame?.totalpend ?? "0") > 0 && (
          <div className="mb-2 d-flex justify-content-end gap-3">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                handlePublish();
              }}
            >
              {intl.formatMessage({ id: "publish" })}
            </button>
          </div>
        )}
      <div
        className="rounded table-responsive"
        style={{ background: "var(--table-background)" }}
      >
        <table className="w-100">
          <thead>
            <tr className="border-bottom">
              <th className={columnClass}>
                {intl.formatMessage({ id: "no" })}
              </th>
              <th className={columnClass}>
                {intl.formatMessage({ id: "category" })}
              </th>
              <th className={columnClass}>
                {intl.formatMessage({ id: "image" })}
              </th>
              <th className={columnClass}>
                {intl.formatMessage({ id: "gameName" })}
              </th>
              <th className={columnClass}>
                {intl.formatMessage({ id: "gameCode" })}
              </th>
              <th className={columnClass}>
                {intl.formatMessage({ id: "gameTag" })}
              </th>
              <th className={columnClass}>
                {intl.formatMessage({ id: "status" })}
              </th>
              <th className={columnClass}>
                {intl.formatMessage({ id: "action" })}
              </th>
            </tr>
          </thead>
          <tbody>
            {companyGameState.companyGame ? (
              companyGameState.companyGame[
                gameStatus === GameStatus.Pending
                  ? "pendingGames"
                  : gameStatus === GameStatus.OnHold
                  ? "onHoldGames"
                  : "publishedGames"
              ].length > 0 ? (
                companyGameState.companyGame[
                  gameStatus === GameStatus.Pending
                    ? "pendingGames"
                    : gameStatus === GameStatus.OnHold
                    ? "onHoldGames"
                    : "publishedGames"
                ].map((companyGame, index) => (
                  <tr key={companyGame.companyGameid} className="border-bottom">
                    <td className={columnClass}>{index + 1}</td>
                    <td className={columnClass}>{companyGame.category}</td>
                    <td className={columnClass}>
                      <img
                        src={companyGame.gameimage}
                        style={{ height: "150px" }}
                      />
                    </td>
                    <td className={columnClass}>
                      <div>{companyGame.gamenameen}</div>
                      <div>{companyGame.gamenamecn}</div>
                    </td>
                    <td className={columnClass}>{companyGame.gamecode}</td>
                    <td className={columnClass}>{companyGame.gametag}</td>
                    <td className={columnClass}>{companyGame.status}</td>
                    <td className={columnClass}>
                      <div className="d-flex">
                        {companyGame.status !== "Delete" && (
                          <button
                            className="btn btn-danger me-1"
                            onClick={() => {
                              handleDelete(
                                companyGame.itemid,
                                companyGame.category
                              );
                            }}
                            title={intl.formatMessage({ id: "deleteGame" })}
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                        )}
                        <button
                          className="btn btn-info me-1"
                          onClick={() => {
                            setItem({
                              itemid: companyGame.itemid,
                              gametype: queryParams.gametype,
                            });
                            setShow(true);
                          }}
                          title={intl.formatMessage({ id: "editGame" })}
                        >
                          <i className="bi bi-pencil-fill"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={7} className={`text-center ${columnClass}`}>
                    {intl.formatMessage({ id: "noRecordFound" })}
                  </td>
                </tr>
              )
            ) : (
              <tr>
                <td colSpan={7} className={columnClass}>
                  <div className="d-flex justify-content-center">
                    <div className="spinner-border" role="status">
                      <span className="sr-only"></span>
                    </div>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
